import { NgFor, NgIf, UpperCasePipe } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { User } from '@angular/fire/auth';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { AuthService } from '@vaki/shared/auth/data-access';
import { ProfileAvatarComponent } from '@vaki/shared/ui/profile-avatar';
import { NewWindowDirective } from '@vaki/shared/util/front-end';
import { CurrencySymbol, Image, Language } from '@vaki/shared/util/interfaces';

@Component({
  selector: 'lib-vakers-shell-ui-menu',
  imports: [
    ProfileAvatarComponent,
    NewWindowDirective,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
    UpperCasePipe,
    NgIf,
    NgFor
  ],
  templateUrl: './vakers-shell-ui-menu.component.html',
  styleUrl: './vakers-shell-ui-menu.component.scss'
})
export class VakersShellUiMenuComponent {
  @Input() user: User | null = null;
  @Input() currentLanguage: string | undefined | null;
  @Input() currentCurrency: string | null = null;
  @Input() logo: Image | undefined | null;
  @Input() currentYear = new Date().getFullYear();
  @Input() currencies: CurrencySymbol[] | null = null;
  @Input() languages: Language[] | undefined;
  @Output() languageSelected = new EventEmitter<string>();
  @Output() currencySelected = new EventEmitter<CurrencySymbol>();
  @Output() logout = new EventEmitter();
  @Output() closeMenu = new EventEmitter();

  auth = inject(AuthService);
}
